import { render } from "./PublicationControls.vue?vue&type=template&id=8db51f06&scoped=true"
import script from "./PublicationControls.vue?vue&type=script&lang=js"
export * from "./PublicationControls.vue?vue&type=script&lang=js"

import "./PublicationControls.vue?vue&type=style&index=0&id=8db51f06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db51f06"]])

export default __exports__